import { useCallback, startTransition } from "react";
import { useNavigate } from "react-router-dom";

/**
 * React Router navigation with startTransition so the current page stays visible
 * until the next route is ready (reduces blink). Browser / App Bridge URL sync
 * runs in BrowserUrlSync after the route commits.
 */
export function useAppNavigate() {
  const rrNavigate = useNavigate();

  return useCallback(
    (to, options) => {
      const searchRaw = typeof to === "string" ? "" : to?.search || "";
      const search =
        searchRaw && !String(searchRaw).startsWith("?") ? `?${searchRaw}` : String(searchRaw || "");

      const target =
        typeof to === "string"
          ? { pathname: to, search }
          : { ...to, search: to?.search != null ? search : to.search };

      startTransition(() => {
        rrNavigate(target, options);
      });
    },
    [rrNavigate],
  );
}
